import { motion } from "framer-motion";
import { Baby, Sparkles, ShieldCheck, Smile, Crown, HeartPulse, Siren, HandHeart } from "lucide-react";

const ITEMS = [
  { icon: Baby, title: "First Visits & Infant Care", text: "Happy first check-ups from the very first tooth, plus guidance for new parents.", bg: "bg-[#ebfbfa]", span: "md:col-span-2" },
  { icon: Sparkles, title: "Cleaning & Fluoride", text: "Gentle polishing and fluoride to keep sugar bugs away.", bg: "bg-[#fef7e5]" },
  { icon: ShieldCheck, title: "Cavity Fillings", text: "Tooth-coloured fillings done calmly, with lots of breaks.", bg: "bg-[#f3f0ff]" },
  { icon: HeartPulse, title: "Root Canals & Pulpectomy", text: "Painless-focused treatment to save baby and permanent teeth.", bg: "bg-[#fff1f1]" },
  { icon: Crown, title: "Crowns for Kids", text: "Strong, shiny crowns that protect treated teeth.", bg: "bg-[#ebfbfa]" },
  { icon: Smile, title: "Braces & Orthodontics", text: "Early checks for crowding, bite and growing smiles.", bg: "bg-[#e0f2fe]", span: "md:col-span-2" },
  { icon: Siren, title: "Dental Emergencies", text: "Knocked-out tooth or sudden toothache? Call us right away.", bg: "bg-[#fff1f1]" },
  { icon: HandHeart, title: "Special Children", text: "Patient, sensory-friendly care for children with special needs.", bg: "bg-[#fef7e5]", span: "md:col-span-3" },
];

export const Services = () => (
  <section id="services" className="mx-auto max-w-7xl px-6 py-24 lg:px-8" data-testid="services-section">
    <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
      <div>
        <span className="text-xs font-bold uppercase tracking-widest text-teal-600">What we do</span>
        <h2 className="mt-3 text-3xl font-bold tracking-tight sm:text-4xl">Care for every little stage</h2>
      </div>
      <p className="max-w-md text-sm text-slate-500 md:text-base">From the first wobbly tooth to teenage braces, every treatment is explained in kid-friendly language.</p>
    </div>
    <div className="mt-12 grid gap-5 md:grid-cols-4">
      {ITEMS.map((s, i) => (
        <motion.div key={s.title} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          transition={{ delay: i * 0.06 }} whileHover={{ y: -6, rotate: i % 2 ? 1 : -1 }}
          data-testid={`service-card-${i}`}
          className={`group rounded-[1.75rem] border-2 border-slate-800/5 p-7 ${s.bg} ${s.span || ""}`}>
          <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-white shadow-sm transition-transform duration-300 group-hover:rotate-12">
            <s.icon className="h-7 w-7 text-teal-600" />
          </div>
          <h3 className="mt-5 text-xl font-semibold">{s.title}</h3>
          <p className="mt-2 text-sm leading-relaxed text-slate-600">{s.text}</p>
        </motion.div>
      ))}
    </div>
  </section>
);
